import { useState, useEffect } from 'react';
import api from '../../api/axios';
import toast from 'react-hot-toast';
import SearchSelect from '../../components/SearchSelect';
import { ShieldCheck, LifeBuoy, KeyRound, Copy } from 'lucide-react';

// Superadmin öz girişi üçün WhatsApp OTP konfiqi (2FA). Limit yoxdur (bloklamır).
export default function SuperadminOtpConfig() {
    const [enabled, setEnabled] = useState(false);
    const [numbers, setNumbers] = useState('');
    const [sender, setSender]   = useState('');
    const [tenants, setTenants] = useState([]);
    const [busy, setBusy]       = useState(false);
    const [hasRecovery, setHasRecovery] = useState(false);
    const [recBusy, setRecBusy] = useState(false);
    const [newCode, setNewCode] = useState('');   // yeni yaradılan kod (bir dəfə göstərilir)

    useEffect(() => {
        api.get('/superadmin/otp-config').then(r => {
            setEnabled(Number(r.data.otp_enabled) === 1);
            setNumbers(r.data.otp_numbers || '');
            setSender(r.data.otp_sender_tenant_id ? String(r.data.otp_sender_tenant_id) : '');
            setHasRecovery(!!r.data.has_recovery);
        }).catch(() => {});
        api.get('/superadmin/tenants').then(r => setTenants(r.data.data || [])).catch(() => {});
    }, []);

    const genRecovery = async () => {
        if (hasRecovery && !window.confirm('Köhnə recovery kod ETİBARSIZ olacaq və yenisi yaranacaq. Davam?')) return;
        setRecBusy(true);
        try {
            const r = await api.post('/superadmin/otp-recovery-code');
            setNewCode(r.data.code);
            setHasRecovery(true);
        } catch {
            toast.error('Recovery kod yaradılmadı.');
        } finally {
            setRecBusy(false);
        }
    };

    const save = async () => {
        setBusy(true);
        try {
            await api.put('/superadmin/otp-config', {
                otp_enabled: enabled,
                otp_numbers: numbers,
                otp_sender_tenant_id: sender ? Number(sender) : null,
            });
            toast.success('Superadmin OTP konfiqi yadda saxlanıldı.');
        } catch (err) {
            toast.error(err.response?.data?.msg || 'Alınmadı.');
        } finally {
            setBusy(false);
        }
    };

    const opts = tenants
        .filter(t => Number(t.whatsapp_enabled) === 1)
        .map(t => ({ value: t.id, label: `${t.name || t.username} (#${t.id})` }));

    return (
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
            {/* ── OTP ── */}
            <div className="rounded-2xl border border-slate-200/80 bg-white p-6 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
                <div className="flex items-start gap-3">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
                        <ShieldCheck className="h-5 w-5" />
                    </div>
                    <div className="min-w-0 flex-1">
                        <div className="text-sm font-semibold text-slate-900">Superadmin giriş OTP</div>
                        <div className="text-xs text-slate-500">WhatsApp ilə 6 rəqəmli təsdiq kodu</div>
                    </div>
                    <label className="flex cursor-pointer items-center gap-2 text-xs font-semibold text-slate-600">
                        <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} className="sa-switch" />
                        {enabled ? 'Aktiv' : 'Sönülü'}
                    </label>
                </div>

                {enabled && (
                    <div className="mt-5 space-y-4">
                        <div>
                            <label className="mb-1.5 block text-xs font-medium text-slate-600">OTP nömrələri</label>
                            <input type="text" value={numbers} onChange={(e) => setNumbers(e.target.value)}
                                placeholder="0994111199, 0504111199"
                                className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 font-mono text-sm text-slate-800 transition focus:border-sky-400 focus:outline-none focus:ring-4 focus:ring-sky-100" />
                        </div>
                        <div>
                            <label className="mb-1.5 block text-xs font-medium text-slate-600">Göndərən tenant (WhatsApp açarı)</label>
                            <SearchSelect value={sender} onChange={setSender} options={opts}
                                placeholder="WhatsApp aktiv tenant seçin" />
                        </div>
                    </div>
                )}

                <p className="mt-4 text-xs leading-relaxed text-slate-500">
                    Superadmin girişində bu nömrələrə 6 rəqəmli kod gedir. <b className="text-slate-700">Limit yoxdur</b>, bloklanmır.
                </p>
                <div className="mt-5 flex justify-end border-t border-slate-100 pt-4">
                    <button onClick={save} disabled={busy}
                        className="rounded-xl bg-[#0090bb] px-5 py-2.5 text-sm font-semibold text-white shadow-sm shadow-sky-900/20 transition-colors hover:bg-[#007ea4] disabled:opacity-50">
                        {busy ? 'Saxlanılır…' : 'Yadda saxla'}
                    </button>
                </div>
            </div>

            {/* ── Recovery kod (WhatsApp itsə) ── */}
            <div className="rounded-2xl border border-slate-200/80 bg-white p-6 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
                <div className="flex items-start gap-3">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-amber-50 text-amber-600">
                        <LifeBuoy className="h-5 w-5" />
                    </div>
                    <div className="min-w-0 flex-1">
                        <div className="text-sm font-semibold text-slate-900">Recovery kod</div>
                        <div className="text-xs text-slate-500">WhatsApp itsə giriş üçün ehtiyat kod</div>
                    </div>
                    <span className={`flex-shrink-0 rounded-full px-2.5 py-1 text-[11px] font-semibold ${hasRecovery ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`}>
                        {hasRecovery ? 'Təyin olunub' : 'Təyin olunmayıb'}
                    </span>
                </div>
                <p className="mt-4 text-xs leading-relaxed text-slate-500">
                    Həm WhatsApp açarını, həm nömrəni itirsən, giriş ekranında <b className="text-slate-700">“Recovery kod ilə gir”</b> ilə
                    (username + parol + bu kod) WhatsApp-suz girirsən. Kodu təhlükəsiz saxla. <b className="text-slate-700">Yalnız bir dəfə göstərilir</b>.
                </p>
                <button onClick={genRecovery} disabled={recBusy}
                    className="mt-4 flex items-center gap-1.5 rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50 disabled:opacity-50">
                    <KeyRound className="h-4 w-4 text-amber-500" />
                    {recBusy ? 'Yaradılır…' : (hasRecovery ? 'Yeni recovery kod yarat' : 'Recovery kod yarat')}
                </button>

                {newCode && (
                    <div className="mt-4 rounded-xl border-2 border-dashed border-amber-300 bg-amber-50/50 p-4 text-center">
                        <div className="text-[11px] font-semibold uppercase tracking-wider text-amber-700">Recovery kod (indi saxla!)</div>
                        <div className="my-2 select-all font-mono text-xl font-bold tracking-wider text-slate-900">{newCode}</div>
                        <button
                            onClick={() => { navigator.clipboard?.writeText(newCode); toast.success('Kopyalandı'); }}
                            className="inline-flex items-center gap-1.5 rounded-lg border border-amber-300 bg-white px-3 py-1.5 text-xs font-semibold text-amber-800 hover:bg-amber-50">
                            <Copy className="h-3.5 w-3.5" /> Kopyala
                        </button>
                        <p className="mt-2 text-[11px] text-rose-600">Bu pəncərəni bağlasan kod bir daha göstərilməyəcək.</p>
                    </div>
                )}
            </div>
        </div>
    );
}
